import dayjs, { Dayjs } from "dayjs"
import { IPaymentSchedule } from "./paymentSchedule.types"
import { formatMoney, formatSeasonalAmount } from "@/helpers/moneyHelpers"
import {
  calcAveragePayment,
  calcSeasonalPayment,
} from "@/helpers/paymentHelper"

export class PaymentSchedule implements IPaymentSchedule {
  id: number
  amount: number
  createdAt: Dayjs
  frequency: string
  frequencyAlignmentDt: Dayjs
  frequencyMultiple: number
  fromDt: Dayjs
  nextPaymentDt: Dayjs
  isSeasonal: boolean
  hasAuthorisedDirectDebit: boolean
  hasAcceptedTerms: boolean
  toDt?: Dayjs

  constructor(
    id: number,
    amount: number,
    createdAt: Dayjs,
    frequency: string,
    frequencyAlignmentDt: Dayjs,
    frequencyMultiple: number,
    fromDt: Dayjs,
    nextPaymentDt: Dayjs,
    isSeasonal: boolean,
    hasAuthorisedDirectDebit: boolean,
    hasAcceptedTerms: boolean,
    toDt?: Dayjs,
  ) {
    this.id = id
    this.amount = amount
    this.createdAt = createdAt
    this.frequency = frequency
    this.frequencyAlignmentDt = frequencyAlignmentDt
    this.frequencyMultiple = frequencyMultiple
    this.fromDt = fromDt
    this.nextPaymentDt = nextPaymentDt
    this.isSeasonal = isSeasonal
    this.hasAuthorisedDirectDebit = hasAuthorisedDirectDebit
    this.hasAcceptedTerms = hasAcceptedTerms
    this.toDt = toDt
  }

  get isActive(): boolean {
    if (!this.toDt) return true
    const now = dayjs()
    return (
      this.toDt.isAfter(this.nextPaymentDt) && this.nextPaymentDt.isAfter(now)
    )
  }

  get amountFormatted(): string {
    return this.isSeasonal
      ? formatSeasonalAmount({ amount: this.averagePayment, divider: "or" })
      : formatMoney({ amount: this.amount }) + "/month"
  }

  get paymentDay(): number {
    return this.nextPaymentDt.day()
  }

  get paymentDayFormatted(): string {
    return this.nextPaymentDt.format("Do") + " of month"
  }

  get averagePayment(): number {
    const month = this.nextPaymentDt.month() + 1
    return calcAveragePayment(this.amount, this.isSeasonal, month)
  }

  get nextPayment(): number {
    const nextMonth = dayjs().add(1, "month").month()
    const avPayment = calcAveragePayment(
      this.amount,
      this.isSeasonal,
      nextMonth,
    )
    return calcSeasonalPayment(avPayment, this.isSeasonal, nextMonth)
  }

  get duration(): string {
    if (this.toDt) {
      return this.toDt.diff(this.fromDt, "day") + " days"
    }
    return "-"
  }
}
